import { useAppState } from "@/modules/app/useAppContext";
import { DbtJobList } from "./DbtJobList";
import { DbtJobsNew } from "./DbtJobsNew";
import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import { useBreadcrumb } from "@/components/breadcrumbs";

export const DbtJobListWrapper = () => {
  const { enableCustomWorkloadsChartAggregation } = useAppState();

  useBreadcrumb("dbt", {
    defaultParents: [{ label: "Code", pathname: "/query" }],
    truncateTo: "/query",
  });

  if (enableCustomWorkloadsChartAggregation) {
    return <DbtJobsNew />;
  }

  return (
    <DatatableContextProvider>
      <DbtJobList />
    </DatatableContextProvider>
  );
};
